<template>
  <header class="header-container" :class="className">
    <div class="sg-center-padding">
      <div class="center topbar">
        <div class="menu">
          <div class="menu-item" v-if="showHome">
            <router-link to="/">
              <i
                class="el-icon-s-home"
                style="font-size: 14px; margin-right: 5px"
              ></i>
              返回首页
            </router-link>
          </div>
          <!-- <div class="menu-item" :style="{ 'padding-left': showHome ? 0 : '45px' }"> -->
          <div class="menu-item">
            <div class="location">
              <dropdown
                ref="provinceDrop"
                :has-arrow="false"
                :is-custom="true"
                @select="handleProvince"
              >
                <template v-slot:title>
                  <h3>
                    <i class="el-icon-location"></i>
                    {{ province }}
                  </h3>
                </template>
                <template v-slot:body>
                  <div class="province-wrap">
                    <div
                      class="province-item"
                      v-for="(item, index) in provinceArray"
                      :key="`${item.code}${index}`"
                      @click="handleChooseProvince(item)"
                    >
                      <span>{{ item.text }}</span>
                    </div>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>

        <div class="clearfix">
          <div class="menu">
            <div class="menu-item">
              <!-- <div>{{ name }}11</div> -->
              <div v-if="!name" class="login-tip">
                您好,&ensp;&ensp;<a class="link" @click="handleLogin">请登录</a>
                <router-link to="/register"><span>立即注册</span></router-link>
              </div>
              <div v-if="name">
                <dropdown
                  ref="userInfo"
                  :is-custom="true"
                  @select="handleProvince"
                >
                  <template v-slot:title>
                    <router-link to="/mine">
                      <h3>{{ name == null ? "暂未填写用户名" : name }}</h3>
                    </router-link>
                  </template>
                  <template v-slot:body>
                    <div class="info-wrap">
                      <div class="logout-wrap">
                        <span @click="hanleLogout">退出</span>
                      </div>
                      <div class="avatar">
                        <div class="avatar-pic">
                          <!-- <img
                            src="https://te--fileservers.oss-cn-hangzhou.aliyuncs.com//file/image/2019/08/15/c624c34656f74279b40a27297595f40d_20190815122436.png"
                            alt=""
                          /> -->

                          <el-image v-if="info.HeadPic" :src="info.HeadPic" />
                          <!-- <el-image
														v-else
														:src="require('@/assets/dash_common/sidebar.png')"
													/> -->
                          <el-image
                            v-else
                            :src="require('@/assets/tourist/avatar.png')"
                          />
                          <!-- <img
                            v-else
                            :src="require('@/assets/dash_common/sidebar.png')"
                            alt=""
                          /> -->
                        </div>
                        <div class="avatar-text">
                          <p>{{ name }}</p>
                        </div>
                      </div>
                      <div class="info">
                        <p class="fl">
                          我的积分：<span class="orange">0</span>
                        </p>
                        <p class="fr">
                          我的邀请码：<span class="black">{{
                            info.CustAccount
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </template>
                </dropdown>
              </div>
            </div>
            <div class="menu-item">
              <dropdown @select="handleSelect">
                <!-- <dropdown> -->
                <template v-slot:title
                  ><span @click="handleSelect">我的配琪</span>
                 </template
                >
                <dropndown-item index="1" path="/mine/ordeRlist"
                  >我的订单</dropndown-item
                >
                <!-- <dropndown-item index="2" path="/service"
									>我的售后</dropndown-item
								>
								<dropndown-item index="3" path="/voucher"
									>我的劵包<span class="dropdown-count">0</span></dropndown-item
								>
								<dropndown-item index="4" path="/contacts"
									>我的人脉</dropndown-item
								>
								<dropndown-item index="5" path="/favourite"
									>店铺收藏</dropndown-item
								> -->
                <!-- <dropndown-item index="2" path="/">我的售后</dropndown-item>
								<dropndown-item index="3" path="/"
									>我的劵包<span class="dropdown-count">0</span></dropndown-item
								>
								<dropndown-item index="4" path="/">我的人脉</dropndown-item>
								<dropndown-item index="5" path="/">店铺收藏</dropndown-item> -->
              </dropdown>
            </div>
            <div class="menu-item hover" @click="handleCart">
              <svg-icon icon-class="shopping" class-name="shopping" />
              购物车
              <b class="shopping-count">{{ cartNum }}</b>
            </div>
            <div class="menu-item hover" @click="handBz">
              帮助中心
              <!-- 帮助中心 -->
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        custom-class="sg-login-dialog"
        :visible.sync="dialogVisible"
        title="请先登录"
        width="400px"
      >
        <login @closeLoginDialog="dialogVisible = false"></login>
      </el-dialog>
    </div>
  </header>
</template>
<script>
import Cookies from "js-cookie";
import Login from "@/components/Login";
import Dropdown from "@/components/Dropdown";
import DropndownItem from "@/components/DropdownItem";
import province from "./province";
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    className: String,
  },
  components: {
    Login,
    Dropdown,
    DropndownItem,
  },
  data() {
    return {
      provinceArray: province,
      province: "",
      showHome: false,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      name: (state) => state.user.name,
      cartNum: (state) => state.merchant.cartNum,
      info: (state) => JSON.parse(state.user.info),
    }),
    ...mapGetters(["token"]),
  },

  watch: {
    // $route(route) {
    //   if (this.device === 'mobile' && this.sidebar.opened) {
    //     store.dispatch('app/closeSideBar', { withoutAnimation: false })
    //   }
    // }
    $route: {
      handler: function (route) {
        // const whiteList = ["/", "/tourist"]
        // if (whiteList.indexOf(route.path) !== -1) {
        // 	this.showHome = false
        // } else {
        // 	this.showHome = true
        // }

        if (this.token && route.name != "dashboard") {
          this.showHome = true;
        } else {
          this.showHome = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  created() {
    // let test=this.name
    const geolocation = new qq.maps.Geolocation();
    if (this.device != "mobile") {
      geolocation.getIpLocation((res) => {
        this.province = res.province;
        // this.matchArea(res);
      });
    } else {
      geolocation.getLocation(
        (res) => {
          this.province = res.province;
          // this.matchArea(res);
        },
        (err) => {
          this.$message.error("请确认已打开定位按钮");
        }
      );
    }
    // this.$store.dispatch("merchant/getCartNum");
  },
  methods: {
    closeLoginDialog(e) {
      this.dialogVisible = e;
    },
    handleLogin() {
      this.dialogVisible = true;
    },
    handleSelect({ key, path }) {
      // if (this.handleIsLogin()) return;
      // this.$router.push(path);
      if (!this.token) {
        this.handleLogin();
        return true;
      }
      if(path==undefined) path ='/mine'
      this.$router.push(path);
      return false;
    },
    handBz() {
      if (!this.token) {
        this.handleLogin();
        return true;
      }
      this.$router.push("/helper");
      return false;
      // if (this.handleIsLogin()) return
    },
    handleCart() {
      if (!this.token) {
        this.handleLogin();
        return true;
      }
      this.$router.push("/cart");
      return false;
      // if (this.handleIsLogin()) return;
      // this.$router.push("/cart");
    },
    handleIsLogin() {
      if (this.$route.path.indexOf("/") > -1) {
        this.handleLogin();
        return true;
      }
      return false;
    },
    handleChooseProvince(res) {
      this.province = res.text;
      this.$refs.provinceDrop.$emit("select", res);
    },
    async hanleLogout() {
      this.$refs.userInfo.$emit("select");
      await this.$store.dispatch("user/logout");
      // 删除购物车数量
      Cookies.remove("cartNum");
      this.$store.commit("merchant/SET_CART_NUM", 0);
      // 删除购物车数量
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    handleProvince(args) {
      console.log(args);
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  //   padding: 0 calc(50% - 600px);
  background: rgba(29, 32, 137, 1);
  width: 100%;
}
.light {
  .header-container {
    background: rgba(232, 232, 232, 1);
    width: 100%;
  }
}
.header-container.light {
  //   padding: 0 calc(50% - 600px);
  background: rgba(232, 232, 232, 1);
  width: 100%;
}
.light {
  .topbar {
    background: rgba(232, 232, 232, 1);
    color: rgba(29, 32, 137, 1);
  }
}

.topbar {
  position: relative;
  // background: #f2f4f5;
  background-color: #1d2089;
  z-index: 90;
  display: flex;
  justify-content: space-between;
  color: rgba(255, 255, 255, 1);
  .location {
    // margin: 0 -10px;
    // margin-left: 30px;
    h3 {
      line-height: 24px;
      cursor: pointer;
      z-index: 10;
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      font-weight: 400;
      i {
        font-size: 14px;
      }
    }
    .province-wrap {
      color: #666;
      margin-top: 10px;
      padding: 0 0 16px;
      display: grid;
      grid-template-columns: repeat(5, auto);
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      .province-item {
        white-space: nowrap;
        &:hover {
          span {
            background-color: #ff4f1a;
            color: #fff;
          }
        }
        span {
          padding: 2px 6px;
        }
      }
    }
  }
  .info-wrap {
    width: 320px;
    padding: 5px 10px;
    line-height: 18px;
    background-color: #fff;
    color: #666;
    .logout-wrap {
      text-align: right;
      span {
        cursor: pointer;
        &:hover {
          color: #ff4f1a;
        }
      }
    }
    .avatar {
      display: flex;
      align-items: center;
      padding: 0 0 14px 0;
      cursor: pointer;
      .avatar-pic {
        width: 40px;
        height: 40px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .avatar-text {
        margin-left: 12px;
      }
    }
    .info {
      padding-top: 10px;
      border-top: 1px dashed #ccc;
      display: flex;
      justify-content: space-between;
      span {
        margin-left: 2px;
        color: #ff4f1a;
        font-weight: bold;
      }
    }
  }
}
.center {
  margin: 0 auto;
}
.clearfix {
  zoom: 1;
}
.clearfix::after {
  clear: both;
  content: "";
  display: block;
}
.menu {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-item {
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.menu-item::after {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 12px;
  margin-top: -6px;
  background-color: #ccc;
  content: "";
}
.menu-item:last-child::after {
  width: 0;
}
.login-tip {
  padding: 0 10px;
  margin: 6px 0;
  line-height: 24px;
}
.login-tip .link:hover {
  color: #ff4f1a;
}
.login-tip > :last-child {
  margin-left: 20px;
  color: #ff4f1a;
}
.dropdown-count {
  margin-left: 2px;
  color: #ff4f1a;
  font-weight: bold;
}
.shopping {
  font-size: 14px !important;
  color: #ff4f1a;
}
.shopping-count {
  color: #ff4f1a;
}
.hover:hover {
  color: #ff4f1a;
}
</style>
<style lang="scss">
.sg-login-dialog {
  .el-dialog__header {
    padding: 10px 12px;
    background-color: #f2f4f5;
    position: relative;
    .el-dialog__headerbtn {
      top: 50%;
      transform: translateY(-50%);
    }
    .el-dialog__title {
      color: #666;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
